import { LabeledValue, AddressValue } from '@/lib/api';

export const EMAIL_LABELS = ['Work', 'Personal', 'Home', 'Other'];
export const PHONE_LABELS = ['Mobile', 'Work', 'Home', 'Other'];
export const ADDRESS_LABELS = ['Home', 'Work', 'Other'];
export const WEBSITE_LABELS = ['Work', 'Personal', 'Home', 'Other'];

export type NameFormat = 'first-last' | 'last-first' | 'last-comma-first';
export type DateFormatOption = 'us' | 'international' | 'iso';

export interface DefaultTemplate {
  categoryId?: string;
  priorityId?: string;
  tags?: string[];
}

export type DuplicateSensitivity = 'off' | 'email-only' | 'email-phone' | 'all';

export interface ContactBookSettings {
  defaultView: 'category' | 'date';
  sortBy: 'name' | 'gatheredAt' | 'company' | 'createdAt';
  sortDir: 'asc' | 'desc';
  selectedCategoryId: string | null;
  nameFormat: NameFormat;
  dateFormat: DateFormatOption;
  defaultTemplate: DefaultTemplate;
  quickAddExpanded: boolean;
  duplicateSensitivity: DuplicateSensitivity;
}

export const DEFAULT_SETTINGS: ContactBookSettings = {
  defaultView: 'category',
  sortBy: 'gatheredAt',
  sortDir: 'desc',
  selectedCategoryId: null,
  nameFormat: 'first-last',
  dateFormat: 'us',
  defaultTemplate: {},
  quickAddExpanded: false,
  duplicateSensitivity: 'email-phone',
};

export const PRESET_COLORS = [
  '#6366f1',
  '#8b5cf6',
  '#ec4899',
  '#ef4444',
  '#f97316',
  '#eab308',
  '#22c55e',
  '#14b8a6',
  '#06b6d4',
  '#3b82f6',
  '#6b7280',
  '#78716c',
];

export type HistoryEntry = { id: string; text: string; date: string; showDate?: boolean };

export interface FormSnapshot {
  firstName: string;
  lastName: string;
  middleName: string;
  namePrefix: string;
  nameSuffix: string;
  nickname: string;
  emails: LabeledValue[];
  phones: LabeledValue[];
  company: string;
  title: string;
  department: string;
  notes: string;
  source: string;
  categoryId: string;
  priorityId: string;
  gatheredAt: string;
  tags: string[];
  addresses: AddressValue[];
  birthday: string;
  anniversary: string;
  websites: LabeledValue[];
  historyEntries: HistoryEntry[];
  isFavorite: boolean;
}
